import React from "react";
import SignUpContent from "./SignUpContent";
import NavBar from "../NavBar";
import Footer from "../Footer";

const SignUpMain = () => {
  return (
    <div className="p-3">
      {/*Add title and metadata */}
      <title>Change Password</title>
      <meta name="robots" content="noindex"></meta>

      {/*navbar*/}
      <NavBar />
      {/* Login body */}
      <SignUpContent />
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default SignUpMain;
